import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import {auth_url,getUserinfo} from "../api/index"
Vue.use(Router)

// 解决路由跳转报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
return originalPush.call(this, location).catch(err => err)
}

var router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  mode:"history",
  // base:"/test",
  base:"/",
  routes: [
    {
      path: '/login',  // 登录
      name: 'login',
      component: resolve => require(['../view/login.vue'], resolve),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/shows', // 展览资讯
      name: 'shows',
      component: resolve => require(['../view/shows.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'展览资讯'
      },
    },
    {
      path: '/briefing',  // 演出介绍资讯
      name: 'briefing',
      component: resolve => require(['../view/briefing.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'演出介绍'
      },
    },
    {
      path: '/science',  // 学术动态资讯
      name: 'science',
      component: resolve => require(['../view/science.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'学术动态'
      },
    },
    {
      path: '/social',   // 社会教育资讯
      name: 'social',
      component: resolve => require(['../view/social.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'社会教育'
      },
    },
    {
      path: '/training', // 培训活动资讯
      name: 'training',
      component: resolve => require(['../view/training.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'培训活动'
      },
    },
    {
      path: '/cloud', // 云赏两馆
      name: 'cloud',
      component: resolve => require(['../view/cloud.vue'], resolve),
      meta: {
        requireAuth: true,
        title:'云赏两馆'
      },
    },
    {
      path: '/cloud_detail',
      name: 'cloud_detail',
      component: resolve => require(['../view/detail/cloud_detail.vue'], resolve),
      meta: {
        requireAuth: true,
        title:''
      },
    },
    {
      path: '/shows_detail',
      name: 'shows_detail',
      meta: {
        requireAuth: true,
        title:''
      },
      component: resolve => require(['../view/detail/shows_detail.vue'], resolve)
     },
    {
      path: '/training_detail',
      name: 'training_detail',
      meta: {
        requireAuth: true,
        title:''
      },
      component: resolve => require(['../view/detail/training_detail.vue'], resolve)
     },
    {
      path: '/briefing_detail',
      name: 'briefing_detail',
      meta: {
        requireAuth: true,
        title:''
      },
      component: resolve => require(['../view/detail/briefing_detail.vue'], resolve)
     },
    {
      path: '/social_detail',
      name: 'social_detail',
      meta: {
        requireAuth: true,
        title:""
      },
      component: resolve => require(['../view/detail/social_detail.vue'], resolve)
     },
    {
      path: '/science_detail',
      name: 'science_detail',
      meta: {
        requireAuth: true,
        title:''
      },
      component: resolve => require(['../view/detail/science_detail.vue'], resolve)
     },
    {
      path: '/contact', // 认识两馆
      name: 'contact',
      meta: {
        requireAuth: true,
        title:'认识两馆'
      },
      component: resolve => require(['../view/pages/contact.vue'], resolve)
     },
    {
      path: '/service', // 爱心服务
      name: 'service',
      meta: {
        requireAuth: true,
        title:'爱心服务'
      },
      component: resolve => require(['../view/pages/service.vue'], resolve)
     },
    {
      path: '/wcsc', // 文创商城
      name: 'wcsc',
      meta: {
        requireAuth: true,
        title:'文创商城'
      },
      component: resolve => require(['../view/pages/wcsc.vue'], resolve)
     },
    {
      path: '/zyfw', // 志愿服务---正在建设中
      name: 'zyfw',
      meta: {
        requireAuth: false,
        title:'志愿服务'
      },
      component: resolve => require(['../view/pages/zyfw_c.vue'], resolve)
     },
    {
      path: '/zyfw_c', // 志愿服务
      name: 'zyfw_c',
      meta: {
        requireAuth: false,
        title:'志愿服务'
      },
      component: resolve => require(['../view/pages/zyfw.vue'], resolve)
     },
    {
      path: '/ycjs', // 演出介绍
      name: 'ycjs',
      meta: {
        requireAuth: true,
        title:'演出介绍'
      },
      component: resolve => require(['../view/pages/ycjs.vue'], resolve)
     },
    {
      path: '*',
      redirect:"/social"
    },
  ]
});
//  授权
router.beforeEach((to, from, next) => {
  var u = navigator.userAgent
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  let token = window.localStorage.getItem("gmg_phone_token1");
  if(to.meta.title){
   document.title = to.meta.title;
  }
  if(to.query.token){
    window.localStorage.setItem("gmg_phone_token1",to.query.token);
    token = to.query.token;
  }
  if (to.meta.requireAuth&&!token) { // 判断该路由是否需要授权权限
    let obj = {
      redirect_uri:window.location.protocol+'//'+window.location.host+to.fullPath
      // redirect_uri:window.location.protocol+'//'+window.location.host+"/test"+to.fullPath
    }
    auth_url(obj).then(res=>{
      if(res.data.errcode==0){
       if(to.query.code){
        getUserinfo({code:to.query.code}).then(resA=>{
          if(resA.data.errcode==0){
            window.localStorage.setItem("gmg_phone_token1",resA.data.data.token);
            if (isiOS && to.path !== location.pathname) {
              location.assign(to.fullPath) // 此处不可使用location.replace
            } else {
              next()
            }
            console.log('授权成功')
          }else{
            console.log('授权失败')
          }
        })
       }else{
        window.location.replace(res.data.data)
       }
      }else{
       console.log(res.data.errdesc)
      }
    })
  } else {
    if (isiOS && to.path !== location.pathname) {
      location.assign(to.fullPath) // 此处不可使用location.replace
    } else {
      next()
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js